export default __webpack_public_path__ + "static/media/list_main_img.3786cb3a.png";